(ns common.schema.entities.workspace.kyc.kyc-options
  (:require [common.util :as cu]))

(def yes-no-options
  [{:key          :yes
    :translations {:en "Yes"
                   :fi "Kyllä"}
    :ord          1.0}
   {:key          :no
    :translations {:en "No"
                   :fi "Ei"}
    :ord          2.0}])

(def true-false-options
  [{:key :true
    :ord 1.0
    :translations {:en "True"}}
   {:key :false
    :ord 2.0
    :translations {:en "False"}}])

(def true-false-na-options
  (conj true-false-options
        {:key :na
         :ord 3.0
         :translations {:en "N/A"}}))

(def attachment-or-url-options
  [{:key          :url
    :translations {:en "Available on website"
                   :fi "Saatavissa web-osoitteessa"}
    :ord          1.0}
   {:key          :attachment
    :translations {:en "Attachment to this form"
                   :fi "Liitetiedostona tällä lomakkeella"}
    :ord          2.0}])

(def crs-classifications
  [{:key          :crs-institution/custodial
    :translations {:en (str "Custodial Institution, Depositary Institution, "
                            "Specified Insurance Company or Investment Entity in "
                            "CRS Participating Jurisdiction")
                   :fi (str "Custodial Institution, Depositary Institution, "
                            "Specified Insurance Company or Investment Entity in "
                            "CRS Participating Jurisdiction")}
    :ord          1.0}
   {:key          :crs-institution/investment-entity-in-non-participating-jurisdiction
    :translations {:en "An Investment Entity in Non-Participating Jurisdiction"
                   :fi "An Investment Entity in Non-Participating Jurisdiction"}
    :ord          2.0}
   {:key          :crs-institution/active-non-financial-entity-publicly-traded
    :translations {:en "Active Non-Financial Entity - publicly traded Non-Financial Entity"
                   :fi "Active Non-Financial Entity - publicly traded Non-Financial Entity"}
    :ord          3.0}
   {:key          :crs-institution/active-non-financial-entity-affiliate-entity-of-publicly-traded
    :translations {:en (str "Active Non-Financial Entity - affiliate entity of a "
                            "publicly traded Non-Financial Entity")
                   :fi (str "Active Non-Financial Entity - affiliate entity of a "
                            "publicly traded Non-Financial Entity")}
    :ord          4.0}
   {:key          :crs-institution/active-non-financial-entity-government-or-central-bank
    :translations {:en "Active Non-Financial Entity - a Government Entity or Central Bank"
                   :fi "Active Non-Financial Entity - a Government Entity or Central Bank"}
    :ord          5.0}
   {:key          :crs-institution/active-non-financial-entity-international-organization
    :translations {:en "Active Non-Financial Entity - an International Organization"
                   :fi "Active Non-Financial Entity - an International Organization"}
    :ord          6.0}
   {:key          :crs-institution/active-non-financial-entity-other
    :translations {:en (str "Active Non-Financial Entity - Other than above "
                            "(e.g. a start-up NFE or a non-profit NFE)")
                   :fi (str "Active Non-Financial Entity - Other than above "
                            "(e.g. a start-up NFE or a non-profit NFE)")}
    :ord          7.0}
   {:key          :crs-institution/passive-non-financial-entity
    :translations {:en "Passive Non-Financial Entity"
                   :fi "Passive Non-Financial Entity"}
    :ord          8.0}
   {:key          :crs-institution/excepted-foreign-financial-institution
    :translations {:en "Excepted Foreign Financial Institution"
                   :fi "Excepted Foreign Financial Institution"}
    :ord          9.0}
   {:key          :crs-institution/us-person-but-not-a-specified-us-person
    :translations {:en "U.S. Person but not a Specified U.S. Person"
                   :fi "U.S. Person but not a Specified U.S. Person"}
    :ord          10.0}])

(def identification-options
  [{:key          :identification.type/passport
    :translations {:en "Passport"
                   :fi "Passi"}
    :ord          1.0}
   {:key          :identification.type/id-card
    :translations {:en "National ID card (valid for travel)"
                   :fi "Virallinen henkilökortti"}
    :ord          2.0}])

(def capman-identification-options
  [{:key          :identification.type/passport
    :translations {:en "Passport"
                   :fi "Passi"}
    :ord          1.0}
   {:key          :identification.type/id-card
    :translations {:en "National ID card (both sides of the card)"
                   :fi "Virallinen henkilökortti (kortin molemmat puolet)"}
    :ord          2.0}])

(def capman-tax-country-tin-status-options
  [{:ord 1.0
    :key :yes-i-have-tin
    :translations {:en "I have a Tax Identification Number (TIN)"
                   :fi "Minulla on verotunnistenumero (TIN)"}}
   {:ord 2.0
    :key :country-does-not-issue-tin
    :translations {:en "The country does not issue a Tax Identification Number (TIN)"
                   :fi "Maa ei myönnä verotunnistenumeroa (TIN)"}}])

(defn resolve-tin-status-label
  [status lang]
  (let [opt (->> capman-tax-country-tin-status-options
                 (cu/filter-by :key status)
                 (first))]
    (when opt
      (get-in opt [:translations lang]))))

(def signer-identification-options
  (concat identification-options
          [{:key          :identification.type/provided-in-previous-questions
            :translations {:en "ID attached in previous steps"
                           :fi "Tunnistamisasiakirja liitetty edellisissä kysymyksissä"}
            :ord          3.0}]))

(def fatca-categories
  [{:key          :fatca.category/partner-jurisdiction-financial-institution
    :translations {:en "Partner Jurisdiction Financial Institution"
                   :fi (str "Kumppanilainkäyttöalueelle sijoittunut finanssilaitos "
                            "(Partner Jurisdiction Financial Institution)")}
    :ord          1.0}
   {:key          :fatca.category/participating-foreighn-financial-institution
    :translations {:en "Participating Foreign Financial Institution (PFFI)"
                   :fi (str "Ulkomainen osallistujafinanssilaitos "
                            "(Participating Foreign Financial Institution, PFFI)")}
    :ord          2.0}
   {:key          :fatca.category/reporting-model-1-ffi
    :translations {:en "Reporting Model 1 FFI"
                   :fi "Raportoitava malli 1 mukainen finanssilaitos (Reporting Model 1 FFI)"}
    :ord          3.0}
   {:key          :fatca.category/registered-deemed-compliant-ffi
    :translations {:en "Registered Deemed Compliant Foreign Financial Institution"
                   :fi (str "Voimassa olevia verosäännöksiä noudattavaksi katsottava "
                            "ulkomainen finanssilaitos (Registered Deemed Compliant FFI)")}
    :ord          4.0}
   {:key          :fatca.category/exempt-beneficial-owner
    :translations {:en "Non-reporting IGA FFI - Exempt Beneficial Owner"
                   :fi "Vapautettu tosiasiallisen etuuden omistaja (Exempt Beneficial Owner)"}
    :ord          5.0}
   {:key          :fatca.category/deemed-compliant
    :translations {:en "Non-reporting IGA FFI – Deemed Compliant FFI"
                   :fi "Ei-raportoiva IGA FFI – Deemed Compliant FFI"}
    :ord          6.0}
   {:key          :fatca.category/certified-deemed-compliant
    :translations {:en "Certified Deemed Compliant Foreign Financial Institution"
                   :fi (str "Todistettavasti voimassaolevia verosäännöksiä noudattavaksi "
                            "katsottava ulkomainen finanssilaitos "
                            "(Certified Deemed Compliant FFI)")}
    :ord          7.0}
   {:key          :fatca.category/non-participating-fi
    :translations {:en "Nonparticipating Financial Institution "
                   :fi (str "Ei-osallistujafinanssilaitos "
                            "(Nonparticipating Financial Institution)")}
    :ord          8.0}
   {:key          :fatca.category/excepted-ffi
    :translations {:en "Excepted Foreign Financial Institution"
                   :fi "Poikkeuksen saanut ulkomainen finanssilaitos (Excepted FFI)"}
    :ord          9.0}
   {:key          :fatca.category/us-person
    :translations {:en "U.S. Person but not a Specified U.S. Person"
                   :fi "Yhdysvaltalainen henkilö, ei määritelty"}
    :ord          10.0}
   {:key          :fatca.category/other
    :translations {:en "Other, please specify"
                   :fi "Muu"}
    :ord          11.0}])

(def lifeline-fatca-categories
  (->> fatca-categories
       (concat
        [{:key          :fatca.category/reporting-model-2-ffi
          :translations {:en "Reporting Model 2 FFI"
                         :fi "Raportoitava malli 2 mukainen finanssilaitos (Reporting Model 2 FFI)"}
          :ord          3.5}])
       (filterv (fn [field]
                  (->> field
                       :key
                       (contains?
                        #{:fatca.category/reporting-model-1-ffi
                          :fatca.category/registered-deemed-compliant-ffi
                          :fatca.category/reporting-model-2-ffi
                          :fatca.category/participating-foreighn-financial-institution}))))
       (sort-by :ord)
       vec))

(def exempt-beneficial-owner-status-options
  [{:key          :exempt-beneficial-owner.status/government-entity
    :translations {:en "Government entity"}
    :ord          1.0}
   {:key          :exempt-beneficial-owner.status/international-organisation
    :translations {:en "International Organisation"}
    :ord          2.0}
   {:key          :exempt-beneficial-owner.status/central-bank
    :translations {:en "Central Bank"}
    :ord          3.0}
   {:key          :exempt-beneficial-owner.status/broad-participation-retirement-fund
    :translations {:en "Broad Participation Retirement Fund"}
    :ord          4.0}
   {:key          :exempt-beneficial-owner.status/narrow-participation-retirement-fund
    :translations {:en "Narrow Participation Retirement Fund"}
    :ord          5.0}
   {:key          :exempt-beneficial-owner.status/pension-fund-of-exempt-beneficial-owner
    :translations {:en "Pension Fund of an Exempt Beneficial Owner"}
    :ord          6.0}
   {:key          :exempt-beneficial-owner.status/investment-entity-wholly-owned-by-exempt-beneficial-owners
    :translations {:en "Investment entity wholly owned by Exempt Beneficial Owners"}
    :ord          7.0}])

(def no-giin-reasons
  [{:key          :no-giin-reason/sponsor
    :translations {:en "Investor is sponsored by another entity which has a GIIN"
                   :fi "Sijoittalla sponsori jolla on GIIN"}
    :ord          1.0}
   {:key          :no-giin-reason/not-obtained
    :translations {:en (str "Partner Jurisdiction Financial Institution that has not yet "
                            "obtained GIIN")
                   :fi (str "Kumppanilainkäyttöalueelle sijoittunut finanssilaitos, "
                            "jolla ei ole vielä GIIN-numeroa")}
    :ord          2.0}
   {:key          :no-giin-reason/other
    :translations {:en "Other, please specify"
                   :fi "Muu"}
    :ord          3.0}])

(def non-financial-classifications
  [{:key          :non-fatca.category/active-NFFE
    :translations {:en "Active Non-Financial Foreign Entity (Active NFFE)"
                   :fi (str "Aktiivinen ulkomainen ei-finanssiyksikkö "
                            "(Active Non-Financial Foreign Entity, Active NFFE)")}
    :ord          1.0}
   {:key          :non-fatca.category/passive-NFFE
    :translations {:en "Passive Non-Financial Foreign Entity (Passive NFFE)"
                   :fi "Passiivinen ulkomainen ei-finanssiyksikkö (Passive NFFE)"}
    :ord          2.0}
   {:key          :non-fatca.category/excepted-NFFE
    :translations {:en "Excepted Non-Financial Foreign Entity"
                   :fi "Poikkeuksen saanut ulkomainen ei-finanssiyksikkö"}
    :ord          3.0}
   {:key          :non-fatca.category/not-specified-USP
    :translations {:en "The Entity is a U.S. Person but not a Specified U.S. Person"
                   :fi "Yhteisö on yhdysvaltalainen henkilö, ei määritelty:"}
    :ord          4.0}
   {:key          :non-fatca.category/other
    :translations {:en "Other"
                   :fi "Muu"}
    :ord          5.0}])

(def lifeline-non-financial-classifications
  [{:key          :non-fatca.category/exempt-beneficial-owner
    :translations {:en "Exempt Beneficial Owner"}
    :ord          1.0}
   {:key          :non-fatca.category/active-NFFE
    :translations {:en "Active Non-Financial Foreign Entity (Active NFFE)"
                   :fi (str "Aktiivinen ulkomainen ei-finanssiyksikkö "
                            "(Active Non-Financial Foreign Entity, Active NFFE)")}
    :ord          2.0}
   {:key          :non-fatca.category/direct-reporting-NFFE
    :translations {:en "Direct Reporting NFFE"}
    :ord          3.0}
   {:key          :non-fatca.category/sponsored-direct-reporting-NFFE
    :translations {:en "Sponsored Direct Reporting NFFE"}
    :ord          4.0}
   {:key          :non-fatca.category/passive-NFFE
    :translations {:en "Passive Non-Financial Foreign Entity"
                   :fi "Passiivinen ulkomainen ei-finanssiyksikkö (Passive NFFE)"}
    :ord          5.0}])

(def legal-form-options
  [{:key          :legal-form/association
    :translations {:en "Association"
                   :fi "Yhdistys"}
    :ord          1.0}
   {:key          :legal-form/alternative-investment-fund
    :translations {:en "Alternative investment fund"
                   :fi "Vaihtoehtorahasto"}
    :ord          2.0}
   {:key          :legal-form/limited-company
    :translations {:en "Limited liability company"
                   :fi "Osakeyhtiö"}
    :ord          3.0}
   {:key          :legal-form/limited-liability-company ;; TODO - rename keyword and run migrations to all kyc forms
    :translations {:en "Limited partnership"
                   :fi "Kommandiittiyhtiö"}
    :ord          4.0}
   {:key          :legal-form/foundation
    :translations {:en "Foundation"
                   :fi "Säätiö"}
    :ord          5.0}
   {:key          :legal-form/pension-fund
    :translations {:en "Pension fund"
                   :fi "Eläkerahasto"}
    :ord          6.0}
   {:key          :legal-form/pension-foundation
    :translations {:en "Pension foundation"
                   :fi "Eläkesäätiö"}
    :ord          7.0}
   {:key          :legal-form/industry-wide-pension-fund
    :translations {:en "Industry wide pension fund"
                   :fi "Eläkekassa"}
    :ord          8.0}
   {:key          :legal-form/mutual-insurance-company
    :translations {:en "Mutual insurance company"
                   :fi "Keskinäinen vakuutusyhtiö"}
    :ord          9.0}
   {:key          :legal-form/mutual-pension-insurance-company
    :translations {:en "Mutual pension insurance company"
                   :fi "Keskinäinen eläkevakuutusyhtiö"}
    :ord          10.0}
   {:key          :legal-form/fund
    :translations {:en "Fund"
                   :fi "Rahasto"}
    :ord          11.0}
   {:key          :legal-form/personnel-fund
    :translations {:en "Personnel fund"
                   :fi "Henkilöstörahasto"}
    :ord          12.0}
   {:key          :legal-form/pension-plan
    :translations {:en "Pension plan"
                   :fi "Eläkevakuutus"}
    :ord          13.0}
   {:key          :legal-form/other
    :translations {:en "Other"
                   :fi "Muu"}
    :ord          14.0}])

(def industry-options
  [{:key          :industry/investment-activities
    :translations {:en "Investment activities"
                   :fi "Sijoitustoiminta"}
    :ord          1.0}
   {:key          :industry/insurance
    :translations {:en "Insurance"
                   :fi "Vakuutus"}
    :ord          2.0}
   {:key          :industry/financing
    :translations {:en "Financing"
                   :fi "Rahoitus"}
    :ord          3.0}
   {:key          :industry/consulting
    :translations {:en "Consulting"
                   :fi "Konsultointi"}
    :ord          4.0}
   {:key          :industry/properties
    :translations {:en "Properties - purchasing, rental or holding"
                   :fi "Kiinteistöjen kauppa, vuokraus tai hallinta"}
    :ord          5.0}
   {:key          :industry/government
    :translations {:en "Government entity"
                   :fi "Julkisoikeudellinen yhteisö"}
    :ord          6.0}
   {:key          :industry/other
    :translations {:en "Other"
                   :fi "Muu"}
    :ord          7.0}])

(def professional-investor-options
  [{:ord          1.0
    :key          :professional-investor.type/FSA-entity
    :translations {:en "Entity supervised by an FSA"
                   :fi "Finanssivalvonnan valvoma yhteisö"}}
   {:ord          2.0
    :key          :professional-investor.type/stock-exchange
    :translations
    {:en
     "Stock exchange, clearing and settlement house or central securities depositary"
     :fi "Pörssi, selvitysyhteisö tai arvopaperikeskus"}}
   {:ord          4.0
    :key          :professional-investor.type/insurance-company
    :translations {:en "Insurance company"
                   :fi "Vakuutusyhtiö"}}
   {:ord          5.0
    :key          :professional-investor.type/pension-insurance-company
    :translations {:en "Pension insurance company, pension trust or pension fund"
                   :fi "Eläkevakuutusyhtiö, eläkekassa tai eläkerahasto"}}
   {:ord          6.0
    :key          :professional-investor.type/derivative-trading
    :translations {:en "Derivative trading entity"
                   :fi "Johdannaiskauppaa tekevä yhteisö"}}
   {:ord          7.0
    :key          :professional-investor.type/commodities-trading-own-account
    :translations
    {:en
     "Undertaking dealing on its own account in commodities and commodity derivative"
     :fi "Hyödykkeitä ja hyödykejohdannaisia omaan lukuunsa ostava ja myyvä yritys"}}
   {:ord          8.0
    :key          :professional-investor.type/government-state-or-county
    :translations {:en "The government, states and counties"
                   :fi "Valtio, osavaltio tai maakunta"}}
   {:ord          9.0
    :key          :professional-investor.type/central-bank
    :translations {:en "Central bank"
                   :fi "Keskuspankki"}}
   {:ord          10.0
    :key          :professional-investor.type/institutional-investor-in-financial-instruments
    :translations
    {:en "Institutional investor whose main activity is investing in financial instruments"
     :fi "institutionaalinen sijoittaja"}}
   {:ord          11.0
    :key          :professional-investor.type/large-undertaking
    :translations {:en "Large undertaking"
                   :fi "Suuryritys"}}
   {:ord          12.0
    :key          :professional-investor.type/other
    :translations {:en "Other professional investor"
                   :fi "Muu ammattimainen sijoittaja"}}])

(def professional-investor-options-person
  [{:key
    :professional-investor-criteria/criteria-1
    :translations
    {:en
     (str "The client has carried out significant-sized transactions "
          "(at least 50,000/transaction) in the markets in question at "
          "an average frequency of ten times per quarter over the "
          "previous four quarters.")
     :fi
     (str "Sijoittaja on toteuttanut huomattavan suuria liiketoimia "
          "(vähintään 50 000 euroa/liiketoimi) kyseisillä markkinoilla "
          "keskimäärin kymmenen kertaa neljännesvuodessa viimeksi "
          "kuluneen neljän vuosineljänneksen aikana.")}
    :ord
    1.0}
   {:key
    :professional-investor-criteria/criteria-2
    :translations
    {:en "The value of the client’s current investment portfolio exceeds EUR 500,000."
     :fi "Sijoittajan sijoitussalkun arvo ylittää 500 000 euroa."}
    :ord
    2.0}
   {:key
    :professional-investor-criteria/criteria-3
    :translations
    {:en
     (str "The client works or has worked in the financial sector in "
          "a professional position for at least one year.")
     :fi
     (str "Sijoittaja tai sijoittajan edustaja työskentelee tai on työskennellyt "
          "rahoitusalalla vähintään vuoden")}
    :ord
    3.0}])

(def large-undertaking-options
  [{:ord          1.0
    :key          :large-undertaking.type/balance-sheet
    :translations {:en "The balance sheet total amounts to at least EUR 20,000,000"
                   :fi "Taseen loppusumma on vähintään 20 000 000 euroa"}}
   {:ord          2.0
    :key          :large-undertaking.type/revenue
    :translations {:en "The revenue is at least EUR 40,000,000"
                   :fi "Liikevaihto on vähintään 40 000 000 euroa"}}
   {:ord          3.0
    :key          :large-undertaking.type/funds
    :translations {:en "Own funds amount to at least EUR 2,000,000"
                   :fi "Omat varat ovat vähintään 2 000 000 euroa"}}])

(def other-investor-type-options
  [{:ord          1.0
    :key          :other-investor.type/significant-transactions
    :translations
    {:en (str
          "The investor has carried out significant-sized transactions "
          "(at least EUR 50,000/transaction) in the markets in question at an average frequency of "
          "ten times per quarter over the previous four quarters")
     :fi
     (str
      "Sijoittaja on toteuttanut huomattavan suuria liiketoimia (vähintään 50 000 euroa/liiketoimi) "
      "kyseisillä markkinoilla keskimäärin kymmenen kertaa neljännesvuodessa viimeksi kuluneen "
      "vuoden aikana.")}}
   {:ord          2.0
    :key          :other-investor.type/current-portfolio
    :translations {:en
                   "The value of the investor’s current investment portfolio exceeds EUR 500,000"
                   :fi "Sijoittajan sijoitussalkun arvo ylittää 500 000 euroa"}}
   {:ord          3.0
    :key          :other-investor.type/professional-position
    :translations
    {:en (str
          "The investor or the representative of the investor works or has worked in the financial "
          "sector in a professional position for at least one year")
     :fi
     "Sijoittaja tai sijoittajan edustaja työskentelee tai on työskennellyt rahoitusalalla vähintään vuoden"}}])

(def source-of-funds-options
  [{:key          :source-of-funds/business-operations
    :translations {:en "Business operations"
                   :fi "Liiketoiminta"}
    :ord          1.0}
   {:key          :source-of-funds/investment-revenues
    :translations {:en "Investment revenues"
                   :fi "Sijoitustoiminnan tulot"}
    :ord          2.0}
   {:key          :source-of-funds/sale-of-investment
    :translations {:en "Sale of investment"
                   :fi "Sijoitusten myynti"}
    :ord          3.0}
   {:key          :source-of-funds/corporate-acquisition
    :translations {:en "Corporate acquisition"
                   :fi "Yrityskauppa"}
    :ord          4.0}
   {:key          :source-of-funds/other
    :translations {:en "Other, specify"
                   :fi "Muu, mikä"}
    :ord          5.0}])

(def source-of-funds-options-person
  [{:key          :source-of-funds/salaries
    :translations {:en "Salaries"
                   :fi "Ansiotulot"}
    :ord          1.0}
   {:key          :source-of-funds/capital-income
    :translations {:en "Capital income"
                   :fi "Pääomatulot"}
    :ord          2.0}
   {:key          :source-of-funds/inheritance
    :translations {:en "Inheritance"
                   :fi "Perintö"}
    :ord          3.0}
   {:key          :source-of-funds/other
    :translations {:en "Other"
                   :fi "Muu"}
    :ord          4.0}])

(def split-of-investments-options
  [{:key :1
    :translations {:en "Listed equity investments"
                   :fi "Osakesijoitukset"}}
   {:key :2
    :translations {:en "Fixed income investments"
                   :fi "Korkosijoitukset"}}
   {:key :3
    :translations {:en "Other investments"
                   :fi "Muut sijoitukset"}}])

(defn source-of-funds-label
  [k lang-kw]
  (let [opt (or (->> source-of-funds-options
                     (filter (fn [o]
                               (= k (:key o))))
                     (first))
                (->> source-of-funds-options-person
                     (filter (fn [o]
                               (= k (:key o))))
                     (first)))]
    (-> opt
        :translations
        (get lang-kw))))
